import styled from '@emotion/styled'

export const LibraryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 4px 12px;
  gap: 4px;
`

export const LibraryBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2px;
`

export const ThumbnailContainer = styled.div`
  position: relative;
  height: 100px;
  overflow: hidden;
  margin: 2px 0px 0px 0;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px !important;
    background: transparent;
    pointer-events: none;
  }
`

export const UploadingContainer = styled.div`
  width: 150px;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-top: 11px;
  height: 89px;
`

export const ImageColumn = styled.div`
  padding: 5px;
`

export const FileNameText = styled.p`
  font-size: 11px;
  margin-bottom: 0;
  padding-top: 5px;
  word-wrap: break-word !important;
`

export const StatusText = styled.p`
  font-size: 11px;
  margin-bottom: 0;
`

export const ProgressText = styled.p`
  font-size: 11px;
  margin-bottom: 0;
  float: right;
`

export const ProgressBar = styled.progress`
  width: 100%;
  height: 4px;
  border-radius: 2px;

  &::-webkit-progress-bar {
    background-color: #f0f0f0;
    border-radius: 2px;
  }

  &::-webkit-progress-value {
    background-color: #1976d2;
    border-radius: 2px;
  }

  &::-moz-progress-bar {
    background-color: #1976d2;
    border-radius: 2px;
  }
`

export const DeleteButton = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;

  &:hover {
    opacity: 0.8;
  }
`

export const FileNameDisplay = styled.span`
  overflow: hidden;
  max-width: 150px;
  margin-top: 4px;
  font-size: 10px;
  display: block;
`

export const Divider = styled.hr`
  margin: 4px 0;
  border: none;
  border-top: 1px solid #e0e0e0;
`
